import { render, staticRenderFns } from "./CPage.vue?vue&type=template&id=c217dd32"
import script from "./CPage.vue?vue&type=script&lang=js"
export * from "./CPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Mutate from 'vuetify/lib/directives/mutate'
import Resize from 'vuetify/lib/directives/resize'
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Mutate,Resize,Touch})
